// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__6hpzz","green":"tag_green__3XzDL","purple":"tag_purple__QP0br"};